import React from 'react'
import './Payment.css'
import { useStateValue } from './StateProvider'
import CheckoutProduct from './CheckoutProduct'

function Payment() {
    const [{basket,user},dispatch]=useStateValue()

    return (
        <div className="payment">
            <div className="payment__container">
            <h1>Checkout {basket?.length} items</h1>
                {/*Delivery Adress*/}
                <div className="payment__section">
                    
                    <div className="payment__title">
                        <h3>Delivery Adress</h3>
                    </div>
                    
                    <div className="payment__adress">
                        <p>{user?.email}</p>
                        <p>Buenos Aires, Argentina</p>
                    </div>
                </div>

                {/*Review Items*/}
                <div className="payment__section">
                    <div className="payment__title">
                        <h3>Review Items and Delivery</h3>
                    </div>

                    <div className="payment__items">
                        {basket.map((item)=>(
                            <CheckoutProduct 
                            id={item.id}
                            title={item.title}
                            price={item.price}
                            rating={item.rating}
                            image={item.image}
                            />
                        ))}
                    </div>
                </div>

                {/*Payment Section*/}
                <div className="payment__section">
                    <div className="payment__title">
                        <h3>Payment Method</h3>
                    </div>

                    <div className="payment__details">
                        
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Payment
